import { render, staticRenderFns } from "./TableInspection.vue?vue&type=template&id=ba985f14&scoped=true"
import script from "./TableInspection.vue?vue&type=script&lang=js"
export * from "./TableInspection.vue?vue&type=script&lang=js"
import style0 from "./TableInspection.vue?vue&type=style&index=0&id=ba985f14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba985f14",
  null
  
)

export default component.exports